import styled from "rn-css";

export const Container = styled.View<{ isNarrow?: boolean }>`
	padding: 0 1rem 0 0.5rem;
	flex-direction: row;
	align-items: center;
`;

export const Label = styled.Text<{ isNarrow?: boolean }>`
	font-size: ${(isNarrow) => (isNarrow ? "16px" : "18px")};
	color: white;
`;
